
import React, { useState } from 'react';
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Box, Button, IconButton } from '@material-ui/core';
import Checkbox from '../checkbox'
import { Link } from "react-router-dom";
import { baseApiUrl } from '../dataProvider/sails';
import Typography from '@material-ui/core/Typography';
import HeaderSortable from '../common/header-sortable';
import { useTranslate } from 'react-admin';
import bin from '../assets/icons/primary-blue-bin.png';
import { useLocation } from "react-router-dom";
import { getDayMonthYear } from '../utils'
import moment from 'moment';
import { Clear, DeleteOutline } from '@material-ui/icons';
import { StyledButton } from '../common/table';
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        borderBottom: 'solid 5px ' + theme.palette.background.default,
        fontWeight: 'inherit'
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 600,
    },
    tableCell: {
        borderBottom: 'solid 5px ' + theme.palette.background.default,
        paddingTop: 8,
        paddingBottom: 8
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
        color: 'white'
    },
    tableSortLabel: {
        fontFamily: 'UniviaPro',
        fontSize: ' 13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: ' 0.13px',
        color: '#ffffff',
        '&:hover': {
            color: '#ffffff'
        },
        '&:focus': {
            color: '#ffffff'
        },
    },
    textTableName: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#237fc2',
        textDecoration: 'none'
    },
    textTable: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    textPublish: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: 'green',
    },
    textPublishNo: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: 'red',
    },
    textTableNoData: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
        textAlign: 'center',
        padding: '30px'
    },
    borderCluster: {
        borderRadius: '10px',
        border: 'solid 1px #e0f0f2',
        backgroundColor: ' #fafefe',
    },
    textCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: ' 0.36px',
        color: '#6cb5b8',
        textAlign: 'center',
        padding: '8px',
    },
    textEdit: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    borderDelete: {
        borderRadius: '12px',
        backgroundColor: '#e5f1f8',
    }
}));

const headCells = [
    { id: 'checkmark', numeric: false, disablePadding: false, label: '' },
    { id: 'name', numeric: false, disablePadding: true, sorting: true, label: 'Name' },
    { id: 'description', numeric: false, disablePadding: false, label: 'Description' },
    { id: '', numeric: false, disablePadding: false, label: '' }
];

function EnhancedTableHead(props) {
    const { classes, order, setOrder, handleCheckMark, data, checked, hidden } = props;

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <StyledTableCell
                        className={classes.tableSortLabel}
                        key={'cell-' + headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                    >
                        {
                            headCell.label !== '' ?
                                (
                                    headCell.label === 'Logo' ?
                                        headCell.label : <HeaderSortable
                                            title={headCell.label}
                                            field={headCell.id}
                                            order={order}
                                            setOrder={setOrder}
                                        />
                                )
                                :
                                headCell.id === 'checkmark' ?
                                    <Box hidden={hidden}>
                                        <Checkbox checked={checked.length === data.length} color='primary' onChange={(event) => handleCheckMark(event, -1, true)} />
                                    </Box> :
                                    <Box />

                        }
                    </StyledTableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}


function CustomTable({ data, getList, buttonHidden, total, onDelete, checked, onClear, handleCheckMark }) {
    const classes = useStyles();
    const translate = useTranslate();
    const location = useLocation();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState({ field: 'name', order: 'ASC' });
    const [anchorEl, setAnchorEl] = useState(null);
    const [openPoper, setOpenPopper] = useState(false);
    const [openedit, setOpenEdit] = useState(false);
    const theme = useTheme()

    const handleChangePage = (event, newPage) => {
        const pagination = { page: newPage + 1, perPage: rowsPerPage };
        getList(order, pagination);
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setPage(0);
        const pagination = { page: 1, perPage: event.target.value };
        getList(order, pagination);
    };

    const handleRequestSort = (nextSort) => {
        setPage(0);
        setOrder(nextSort);

        const pagination = { page: 1, perPage: rowsPerPage };
        getList(nextSort, pagination);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleCloseEdit = () => {
        setOpenEdit(!openedit);
    };

    return (

        // error > 0 ?
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table aria-label="sticky table">
                    {
                        checked.length > 0 ? (
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px' }}><Checkbox checked={checked.length === data.length} color='primary' onChange={(event) => handleCheckMark(event, -1, true)} />
                                        <StyledButton
                                            onClick={onDelete}
                                            variant='text'
                                            startIcon={<DeleteOutline />}
                                        >{translate(`pos.common.delete`)}</StyledButton>
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px' }}></TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px' }}></TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '8px 0' }} align='right'>
                                        <StyledButton
                                            onClick={onClear}
                                            variant='text'
                                            startIcon={<Clear />}
                                        >{checked.length} {checked.length > 1 ? translate('pos.categories.filesSelected') : translate('pos.categories.fileSelected')}</StyledButton>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                        ) :
                            < EnhancedTableHead checked={checked} data={data} handleCheckMark={handleCheckMark} classes={classes} order={order} setOrder={handleRequestSort} hidden={buttonHidden} />
                    }
                    <TableBody>
                        {
                            data.map((item, index) => (
                                <TableRow key={'table-row-' + index} hover tabIndex={-1}>
                                    <TableCell key={index + '-3'} style={{ width: 150 }} className={classes.tableCell}>
                                        <Box hidden={buttonHidden}>
                                            <Checkbox onClick={(e) => { e.stopPropagation() }} checked={item.checked ? true : false} onChange={(event) => handleCheckMark(event, index)} color='primary' />
                                        </Box>
                                    </TableCell>
                                    <TableCell key={index + '-0'} className={classes.tableCell} style={{ color: theme.palette.primary.main, cursor: 'pointer' }}>
                                        <Typography className={classes.textTable}>{item.name}</Typography>
                                    </TableCell>
                                    <TableCell key={index + '-1'} className={classes.tableCell}>
                                        <Typography className={classes.textTable}>{item.description}</Typography>
                                    </TableCell>

                                    <TableCell key={index + '-2'} className={classes.tableCell} align='right'>
                                        {
                                            !buttonHidden &&
                                            <Box>
                                                <Button
                                                    variant="contained"
                                                    color='primary'
                                                    size='small'
                                                    component={Link}
                                                    to={{
                                                        pathname: "Keymap/" + item.id
                                                    }}
                                                    style={{ marginRight: 8 }}
                                                >
                                                    <Typography className={classes.textEdit} style={{ padding: '8px' }}>{translate(`pos.remoteControl.mapping`)}</Typography>
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color='primary'
                                                    size='small'
                                                    component={Link}
                                                    to={{
                                                        pathname: "/Remote/" + item.id
                                                    }}
                                                >
                                                    <Typography className={classes.textEdit} style={{ padding: '8px' }}>{translate(`pos.user.edituser`)} </Typography>
                                                </Button>

                                            </Box>
                                        }


                                    </TableCell>
                                </TableRow>
                            ))
                        }

                    </TableBody>
                </Table>
            </TableContainer>


            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={total}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper>
        //  :<Typography className={classes.textTableNoData}>{translate(`pos.user.error.datanotfound`)} </Typography>
    );
}

export default CustomTable;
